const sellerDetailedTypeOptions = [
  { id: "Financial company/Lending", label: "Financial company/Lending" },
  { id: "Fleet/Lease companies", label: "Fleet/Lease companies" },
  { id: "Rental Company", label: "Rental Company" },
  { id: "Wholesale", label: "Wholesale" },
  { id: "Charity", label: "Charity" },
  { id: "Dealer", label: "Dealer" },
  { id: "Insurance", label: "Insurance" }
];

const sellerDetailedTypeAPIKey = "seller_detailed_type";
const sellerDetailedTypeLabel = "Seller Type";

export { sellerDetailedTypeOptions, sellerDetailedTypeAPIKey, sellerDetailedTypeLabel };


